import { QueryOptions } from "../Common/useQuery";
import useUserQuery from "../Common/useUserQuery";
import { useUser } from "../UserAccess/useUser";

export enum Status {
  Error = 'Error',
  Syncing = 'Syncing',
  Warning = 'Warning',
  Operational = 'Operational',
  NotRegistered = 'NotRegistered',
}

export type SiteStatusDto = {
  siteName: string,
  status: Status,
  pendingNotificationCount: number,
  error?: string,
  siteKey?: string,
  pcName?: string
}

const useGetSitesStatus = (options?: QueryOptions<SiteStatusDto[]>) => {
  const user = useUser();

  return useUserQuery<SiteStatusDto[]>(
    { path: `/api/businesses/${user.selectedBusiness?.id!}/sitesStatus` },
    options);
}

export default useGetSitesStatus;
